import React from 'react';

const Footer = () => (
	<div className="footer">
		Copyright 2019 <a href="https://rodrigodlpontes.github.io/website/">Rodrigo Pontes</a>,
		Copyright 2011 <a href="http://www.cs.usfca.edu/galles">David Galles</a>
	</div>
);

export default Footer;
